module.exports = __webpack_public_path__ + "img/banner-1.58863217.jpg";